import {colorSwatch} from '../utils/colorSwatch.js';
import {MenuPanels} from '../../models/UIModel.js';
import {MenuButton} from '../components/menu-button.js';
import {ShoppeBase} from './shoppe-base.js';
import {Column, Container, Text} from '@wonderlandengine/react-ui/components';
import {Align, Justify} from '@wonderlandengine/react-ui';
import {goToPreviousMenu} from '../utils/goToPreviousMenu.js';
import {AdManager, AdRewardTypes} from '../../components/ad-manager.js';
import {Carousel, CarouselItem} from '../components/carousel.js';
import {SliderItem} from '../components/SliderComponent.js';
import {Header} from '../components/header.js';
import {insertNewlines, setAlpha} from '../utils/utils.js';
import {useRotBMaterialContext} from '../utils/rotb-material-context.js';
import React, {useMemo} from 'react';
import {openLink} from '../utils/openLink.js';
import {Statistics} from '../../components/statistics.js';
import {TransactionalNames} from '../../enums/TransactionalNames.js';
import {UiTexturesManager} from '../components/ui-textures-manager.js';
import {ConfirmationDialogController} from './confirmation-dialog.js';
import {formatNumber} from '../../utils/Utils.js';
import {Localization} from '../../utils/Localization.js';
import {isString} from '@wonderlandengine/api';
import {Analytics, AnalyticsEvent} from '../../classes/Analytics.js';

function adReward({e}) {
    AdManager.instance.getAdReward(AdRewardTypes.CoinReward, e).then(({type, coins}) => {
        Analytics.LogEventWithValue(AnalyticsEvent.BoughtCoins, coins, 'AdRewardCoins');
        ConfirmationDialogController.instance.displayDialog(
            `You got ${formatNumber(coins)} coins!`,
            'YEAH!'
        );
    });
}

const shareObject = {
    title: 'Rise of the Blobs',
    text: 'Check out Rise of the Blobs!',
    url: 'https://riseoftheblobs.com',
};

export const ShoppeCoins = () => {
    const mats = useRotBMaterialContext();
    const [description, setDescription] = React.useState('');
    const [title, setTitle] = React.useState('');
    const [selectedId, setSelectedId] = React.useState(1);

    const showShare = useMemo<boolean>(() => {
        return (
            navigator.share !== undefined &&
            navigator.canShare !== undefined &&
            navigator.canShare(shareObject)
        );
    }, []);

    const onClick = ({e}) => {
        switch (selectedId) {
            case 1:
                adReward({e});
                break;
            case 2:
                // refactor and add a cooldown.
                navigator
                    .share(shareObject)
                    .then(() => {
                        Statistics.instance.addAnonymousPurchaseTransaction(
                            TransactionalNames.CoinCount,
                            50
                        );
                    })
                    .catch((e) => {
                        console.log(e);
                    });

                break;
        }
    };
    const onSelectionChanged = (item: SliderItem) => {
        if (isString(item.id)) {
            setSelectedId(parseInt(item.id));
        } else {
            setSelectedId(item.id);
        }
        switch (item.id) {
            case '1':
                setTitle('Watch Ad');
                setDescription('Watch an ad to get 125 coins!');
                break;
            case '2':
                setTitle('Share');
                setDescription('Share the game to get 50 coins!');
                break;
        }
    };

    return (
        <ShoppeBase
            hideBuyCoins={true}
            title={Localization.instance.get('CoinStoreTitle')}
            onOkay={() => goToPreviousMenu(MenuPanels.StoreCoins)}
        >
            <Column flexGrow={1}>
                <Carousel loop={false} onSelectionChanged={onSelectionChanged}>
                    <CarouselItem
                        title="Watch Ad"
                        id="1"
                        image={UiTexturesManager.instance.buttonAd}
                    ></CarouselItem>
                    {showShare && (
                        <CarouselItem
                            title="Share"
                            id="2"
                            image={UiTexturesManager.instance.buttonShare}
                        ></CarouselItem>
                    )}
                </Carousel>
                <Header
                    title="GET COINS!"
                    color={colorSwatch.SubTitleHighBackground}
                    center={true}
                    height={100}
                />
                <Container
                    alignSelf={Align.Center}
                    alignItems={Align.FlexStart}
                    justifyContent={Justify.Center}
                    margin={20}
                >
                    <MenuButton
                        width={180}
                        height={80}
                        color={colorSwatch.GetCoinsButton}
                        fontSize={20}
                        onClick={onClick}
                    >
                        {Localization.instance.get('GetCoins')}
                    </MenuButton>
                </Container>
                <Container flexGrow={1} alignItems={Align.Center} margin={20}>
                    <Text
                        width={400}
                        color={setAlpha(colorSwatch.DescriptionText, '90%')}
                        material={mats.regularTextMaterial}
                        fontSize={20}
                        textAlign="center"
                        textWrap="soft"
                    >
                        {description}
                    </Text>
                </Container>
            </Column>
        </ShoppeBase>
    );
};
